import React, { useState, Component, useEffect }  from 'react'
import { View, StyleSheet, FlatList, TouchableOpacity } from 'react-native'
import StyledTextInput from '../../components/StyledTextInput'
import { Text, useTheme } from '@ui-kitten/components' 
import { useTranslation } from 'react-i18next'
import { atom, useAtomValue } from 'jotai'
import { constantsAtom, dbAtom } from '../../global/AtomsProvider'

export default function ComplexSaleTemplatesList( { onItemPress, style, showEmptyTemplate } ) {
  const theme = useTheme()
  const { t } = useTranslation()
  let db = useAtomValue(dbAtom)
  const [templates, setTemplates] = useState()
  const [data, setData] = useState()
  const [query, setQuery] = useState('')
  const _list = React.createRef()

  // useEffect(() => {
  //   if (templates.data && showEmptyTemplate) {
  //     setData([{templateName: t('complexSales.emptyTemplate')}, ...templates.data])
  //   } else {
  //     setData(templates.data)
  //   }
  // }, [templates.data])

  useEffect(() => {
    let unsubscribe = db.collection('constants').doc('complexSaleTemplates').collection('data').onSnapshot(snapshot => {
      let templates = showEmptyTemplate ? [{templateName: t('complexSales.emptyTemplate')}] : []
      snapshot.forEach(doc => {
        let template = doc.data()
        template.id = doc.id
        template.ref = doc.ref
        templates.push(template)
      })
      setTemplates(templates)
      setData(templates)
    })
    return () => unsubscribe()
  }, [])
  
  const handleSearch = text => {
    setQuery(text)
    var filteredData = templates.data?.filter(function(template) {
      return template.name.toLowerCase().indexOf(text.toLowerCase()) > -1;
    })   
    if (text === '') {
      filteredData = []
    }
    setData(filteredData)
  }

  const renderSearchHeader = () => (
    <SearchHeader setData={setData} query={query} handleSearch={handleSearch} searchWord={t('search')} allWord={t('all')} />
  )

  const renderItem = ({item, index}) => (
    <Row item={item} index={index} onItemPress={onItemPress} backgroundColor={theme['background-basic-color-1']} />
  )


  return (
    <View style={[{flex: 1, alignItems: 'stretch'}, style ]}>
      {/* {renderSearchHeader()} */}
      <FlatList 
        ref={_list}
        ListHeaderComponent={renderSearchHeader()}
        initialNumToRender={20}
        data={data}
        keyExtractor={(item, index) => item.id}
        renderItem={renderItem}
        style={styles.list} 
        keyboardDismissMode='on-drag'
        keyboardShouldPersistTaps='handled'
        ListFooterComponent={() => <View style={{height: 50}}></View>}
      />
    </View>   
  )
}

class Row extends Component {

  shouldComponentUpdate(nextProps, nextState) {
    if (this.props.item.id !== nextProps.item.id) {
      return true;
    }
    if (this.props.item.templateName !== nextProps.item.templateName) {
      return true;
    }
    return false;
  }

  render() { 
    return (
      <TouchableOpacity
        style={[styles.item, {backgroundColor: this.props.backgroundColor}]}
        onPress={() => {
          this.props.onItemPress(this.props.item, this.props.index)
        }}
        key={this.props.item.id}
      >
        <Text
          style={styles.itemTitle}
          category='s2'>
          {this.props.item.templateName}
        </Text> 
      </TouchableOpacity>
    )
  }
}

class SearchHeader extends Component {

  shouldComponentUpdate(nextProps, nextState) {
    if (this.props.query !== nextProps.query) {
      return true;
    }
    return false;
  }

  render() { 
    return (
      <View style={styles.listHeader}>
        <StyledTextInput autoCapitalize="none"
          autoCorrect={false}
          clearButtonMode="always"
          value={this.props.query}
          onChangeText={queryText => this.props.handleSearch(queryText)}
          placeholder={this.props.searchWord} 
          returnKeyType='done'
          style={styles.input}
          selectTextOnFocus={true}
        />
      </View>
    )
  }
}
  
const styles = StyleSheet.create({
  list: {
    paddingHorizontal: 20,
  },
  input: {
    marginTop: 20,
  },
  item: {
    flexDirection: 'row',
    alignItems: 'center',
    marginVertical: 2,
    paddingHorizontal: 14,
    borderRadius: 5,
    height: 56,
  },
  listHeader: {
    // height: 200,
    justifyContent: 'center',
    marginBottom: 10
    // position: Platform.OS === 'web' ? 'fixed' : undefined,
    // top: Platform.OS === 'web' ?  0 : undefined,
    // zIndex: Platform.OS === 'web' ? 4 : undefined, 
    // backgroundColor: Platform.OS === 'web' ? 'white' : undefined, 
    // paddingHorizontal: Platform.OS === 'web' ? 20 : undefined,
  }
})